import React from "react";
import { Box } from "@mui/material";
import { ActionButton } from "../../components/buttons";

const StepFooterActions = ({
  activeStep,
  onBack,
  onNext,
  isLastStep,
  loading,
  isSubmitting,
  disabled,
  submitDisabled,
  onSubmit,
  isBackDisabled = false,
}) => {
  const primaryProps = isLastStep
    ? {
        onClick: onSubmit,
        loading: isSubmitting,
        disabled: loading || submitDisabled,
        label: isSubmitting ? "Submitting..." : "Submit",
      }
    : {
        onClick: onNext,
        loading,
        disabled,
        label: loading ? "Saving..." : "Save & Continue",
      };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        pt: 3,
        borderTop: "1px solid #E6ECEA",
      }}
    >
      <ActionButton
        variant="text"
        label="Back"
        onClick={onBack}
        disabled={activeStep === 0 || loading || isBackDisabled}
      />

      <ActionButton variant="contained" {...primaryProps} />
    </Box>
  );
};

export default StepFooterActions;
